<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item :label="language['common.creator']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'createBy']" ></a-input><!--:placeholder="language['common.inputCreator']"-->
        </a-form-item>
        <a-form-item :label="language['common.createTime']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date  v-decorator="[ 'createTime']" :trigger-change="true" style="width: 100%"/>
        </a-form-item>

        <a-form-item :label="language['common.modifier']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'updateBy', validatorRules.updateBy]" ></a-input>
        </a-form-item>
        <a-form-item :label="language['common.modifyTime']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date  v-decorator="[ 'updateTime', validatorRules.updateTime]" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item :label="language['serial.docCat']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'docCat', validatorRules.docCat]" ></a-input>
        </a-form-item>
        <a-form-item :label="language['serial.prefix']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'prefix', validatorRules.prefix]" ></a-input>
        </a-form-item>
        <a-form-item :label="language['serial.dateFormat']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'dateFormat', validatorRules.dateFormat]" ></a-input>
        </a-form-item>
        <a-form-item :label="language['serial.currentDate']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'currDate', validatorRules.currDate]" ></a-input>
        </a-form-item>
        <a-form-item :label="language['serial.dataFormat']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'numberFormat', validatorRules.numberFormat]" ></a-input>
        </a-form-item>
        <a-form-item :label="language['serial.currentData']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'currNo', validatorRules.currNo]" ></a-input>
        </a-form-item>
        <a-form-item :label="language['serial.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'remark', validatorRules.remark]" ></a-input>
        </a-form-item>
        <a-form-item :label="language['serial.activeFlag']" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <!--<a-input v-decorator="[ 'activeFlag', validatorRules.activeFlag]" ></a-input>-->
          <j-dict-select-tag  dictCode="active_flag" v-decorator="[ 'activeFlag', validatorRules.activeFlag]" ></j-dict-select-tag>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import { get, pick } from 'lodash';
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'

  export default {
    name: "TBmSerialnoModal",
    components: {
      JDate,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:this.$store.getters.language['common.action'],
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,

        url: {
          add: "/sys/system/tBmSerialno/add",
          edit: "/sys/system/tBmSerialno/edit",
        }
      }
    },
    created () {
    },
    computed: {
      language(){
        return this.$store.getters.language;
      },

      validatorRules() {
        if(this.language){
          return {
          createBy: {rules: [
            {required: true, message: this.language['common.inputCreator']},
          ]},
          createTime: {rules: [
            {required: true, message: this.language['common.pleaseInput']+this.language['common.createTime']},
          ]},
          updateBy: {rules: [
          ]},
          updateTime: {rules: [
          ]},
          docCat: {rules: [
            {required: true, message: this.language['serial.inputdocCat']},
          ]},
          prefix: {rules: [
          ]},
          dateFormat: {rules: [
          ]},
          currDate: {rules: [
          ]},
          numberFormat: {rules: [
          ]},
          currNo: {rules: [
            {required: true, message: this.language['common.inputCurrentNo']},
          ]},
          remark: {rules: [
          ]},
          activeFlag: {rules: [
            {required: true, message: this.language['common.inputIsValid']},
          ]},
        }

        }

      },
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        //debugger
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'createBy','createTime','updateBy','updateTime','docCat','prefix','dateFormat','currDate','numberFormat','currNo','remark','activeFlag'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }

        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'createBy','createTime','updateBy','updateTime','docCat','prefix','dateFormat','currDate','numberFormat','currNo','remark','activeFlag'))
      },


    }
  }
</script>